// Snippets
import './snippets/lsg-flavor-characteristic';